import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormValidationModule } from '@tablesready/common-ui';
import { SettingsComponent } from './settings.component';
import { SettingsRoutingModule } from './settings.routing.module';
import { BillingModule } from './billing/billing.module';
import { IonicModule } from '@ionic/angular';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { AppVariablesModule } from '@tablesready/frontend-variables';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [SettingsComponent],
  imports: [
    FrontendIconsModule,
    CommonModule,
    SettingsRoutingModule,
    AppVariablesModule,
    AlertsModule,
    StatusModule,
    BillingModule,
    NgbModule,
    FormValidationModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendPullRefreshModule,
  ],
})
export class SettingsModule {}
